module.exports = __webpack_public_path__ + "kz.5d76f13884ac0ca882aa.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/kz.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/kz.svg
// module chunks = styles